import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import DownloadButton from '../../shared/DownloadButton';
import EventsByTimeOfDayChart from './EventsByTimeOfDayChart';
import timeOfDayEventsData from './timeOfDayEventsData';
import DropDownButton, { DropDownMenu } from '../../shared/DropDownButton';
import { useTranslation } from 'react-i18next';

export default function EventsByTimeOfDay() {
    const { t } = useTranslation();

    const data = timeOfDayEventsData;
    const menus: DropDownMenu[] = [
        { label: 'By Week', value: 'week' },
        { label: 'By Month', value: 'month' },
        { label: 'By Year', value: 'year' }
    ];
    const exportMenus: DropDownMenu[] = [{ label: 'PDF', value: 'pdf' }, { label: 'CSV', value: 'csv' }];


    return (

        <Grid item={true} xs={8}>
            <FFPaper
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    justifyContent: 'top',
                    height: '100%',
                    pb: 1
                }}
            >
                <Stack direction="row" spacing={2} sx={{ pt: 2, pr: 2, pb: 0, pl: 2 }}>
                    <Title big={true} info="This graph represents number of Events">Events By Time of Day</Title>

                    <Stack direction="row" spacing={2} sx={{ pr: 1, pb: 1, mb: 1 }}>
                        <DropDownButton boxShadow={false} 
                        defaultLabel={t('app_export_data')} 
                        color="text.primary" 
                        backgroundColor="button.main" 
                        fontSize={14} 
                        data={exportMenus} />

                        <DownloadButton />

                        <DropDownButton defaultLabel='By Week' fontSize={15} data={menus} color="text.primary" />
                    </Stack>
                </Stack>
                <Box sx={{ mt: 0, height: '100%', display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <Stack direction="row" sx={{ width: '100%', ml: 1, pr: 2, justifyContent: 'center' }}>
                        <EventsByTimeOfDayChart data={data} />
                    </Stack>
                </Box>
            </FFPaper>
        </Grid>

    )

}
